var N = Object.defineProperty;
var l = (d, t) => N(d, "name", { value: t, configurable: !0 });
const v = Symbol("isProxy");
function b(d) {
  return d.replace(/\B([A-Z])(?=[a-z])/g, "-$1").replace(/\B([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
l(b, "camelToDash");
function E(d) {
  return d.replace(/-([a-z])/g, (t) => t[1].toUpperCase());
}
l(E, "dashToCamel");
function C(d, t, e = {
  attributes: !0,
  childList: !0,
  subtree: !0
}) {
  const s = new MutationObserver(t);
  return s.observe(d, e), s;
}
l(C, "createObserver");
function g(d, ...t) {
  console.warn(`[Minze warn] ${d}`, ...t);
}
l(g, "warn");
var p;
const A = (p = class {
  /**
   * Defines a custom element.
   *
   * @param name - The name of the custom element.
   * @param element - The element extending the MinzeElement class.
   *
   * @example
   * ```
   * class MyElement extends MinzeElement {}
   * Minze.define('my-element', MyElement)
   * ```
   */
  static define(t, e) {
    customElements.get(t) ?? customElements.define(t, e);
  }
  /**
   * Defines multiple custom elements.
   *
   * All class names have to be in PascalCase for automatic dash-case name conversion.
   * Example: `MinzeElement` will be registered as `<minze-element></minze-element>`.
   *
   * The parameters filter and keys have only an effect when elementsOrModules is actually a
   * module-map. E.g. Object returned by vite `import.meta.glob`.
   *
   * @param elementsOrModules - A module object, a module-map or an array of Minze elements.
   * @param filter - An array of keys that narrows down which modules of a module-map should be defined.
   * @param keys - A callback function that will be applied to every key.
   *
   * @default
   * keys = (key) => key.replace(/^\.\/lib\/|\.(ts|js)$/gi, '') // removes './lib/', '.ts' and '.js'
   *
   * @example
   * ```
   * // array
   * import { MinzeElement, MinzeElementTwo } from './elements'
   * Minze.defineAll([ MinzeElement, MinzeElementTwo ])
   *
   * // module
   * import * as elements from './elements'
   * Minze.defineAll(elements)
   *
   * // module-map
   * const modules = {
   *   'element': () => import('./path/to/file.js')
   * }
   * Minze.defineAll(modules)
   *
   * // module-map (vite)
   * const modules = import.meta.glob('./lib/*.@(ts|js)')
   * Minze.defineAll(modules)
   * ```
   */
  static defineAll(t, e, s = (i) => i.replace(/^\.\/lib\/|\.(ts|js)$/gi, "")) {
    const i = /* @__PURE__ */ l((n) => typeof n == "function" && "define" in n && typeof n.define == "function", "isMinzeElement");
    !Array.isArray(t) && Array.isArray(e) && e.every((n) => typeof n == "string") && (t = p.enhanceModules(t, e, s));
    function r(n) {
      i(n) && n.define();
    }
    l(r, "defineMinzeElement");
    function o(n) {
      typeof n == "object" && n !== null && Object.values(n).forEach(async (c) => {
        r(c);
      });
    }
    l(o, "defineModule"), Object.values(t).forEach(async (n) => {
      if (i(n))
        r(n);
      else if (typeof n == "object" || typeof n == "function") {
        const c = typeof n == "function" ? await n() : n;
        i(c) ? r(c) : o(c);
      }
    });
  }
  /**
   * Creates an enhanced consumable map of modules for `Minze.defineAll`.
   *
   * @param modules - A module object.
   * @param filter - An array of strings that narrows down which modules should be included.
   * @param keys - A callback function that will be applied to every key.
   *
   * @example
   * ```
   * Minze.enhanceModules(modules, ['first-module', 'second-module'], (key) => key)
   * ```
   */
  static enhanceModules(t, e, s) {
    return Object.fromEntries(
      Object.entries(t).map(([i, r]) => (s && typeof s == "function" && (i = s(i)), e != null && e.includes(i) || !e ? [i, r] : [])).filter((i) => i.length)
    );
  }
  /**
   * Dispatches a custom event on the `window` object.
   *
   * @param eventName - The name of the event.
   * @param detail - The detail data to be passed with the event.
   *
   * @example
   * ```
   * Minze.dispatch('minze:update', { amount: 10 })
   * ```
   */
  static dispatch(t, e) {
    dispatchEvent(
      new CustomEvent(t, {
        detail: e,
        bubbles: !0,
        composed: !0,
        cancelable: !0
      })
    );
  }
  /**
   * @deprecated use dispatch instead.
   */
  static cast(t, e) {
    g("cast is deprecated use dispatch instead."), this.dispatch(t, e);
  }
  /**
   * Adds an event listener to the `window` object
   * for the provided event name and callback function.
   *
   * @param eventName - The name of the event.
   * @param callback - The callback function to be called when the event is dispatched.
   *
   * @example
   * ```
   * Minze.listen('minze:update', (event) => {})
   * ```
   */
  static listen(t, e) {
    addEventListener(t, e);
  }
  /**
   * Removes event listener based on the provided event name and
   * callback function from the `window` object.
   *
   * @param eventName - The name of the event.
   * @param callback - The callback function to be removed.
   *
   * @example
   * ```
   * Minze.stopListen('minze:update', (event) => {})
   * ```
   */
  static stopListen(t, e) {
    removeEventListener(t, e);
  }
}, l(p, "_Minze"), p);
A.version = "1.10.1";
let _ = A;
function R(d, t, e) {
  const s = /* @__PURE__ */ l((i) => {
    i = typeof i == "function" ? i() : i;
    const r = document.createElement("template");
    return r.innerHTML = i, r;
  }, "render");
  x(s(d), e), w(s(d), s(t), e);
}
l(R, "deepPatch");
function x(d, t) {
  const s = d instanceof HTMLTemplateElement ? d.content.childNodes : d.childNodes;
  if (s.length !== t.childNodes.length) {
    t.textContent = d.textContent;
    return;
  }
  Array.from(s).forEach((i, r) => {
    const o = i, n = t.childNodes[r];
    o.isEqualNode(n) || (n.nodeType === Node.TEXT_NODE || n.nodeType === Node.COMMENT_NODE ? n.textContent = o.textContent : n.nodeType === Node.ELEMENT_NODE && x(o, n));
  });
}
l(x, "deepPatchText");
function w(d, t, e) {
  const s = /* @__PURE__ */ l((o) => o instanceof HTMLTemplateElement ? o.content.children : o.children, "children"), i = s(d), r = s(t);
  if (i.length !== e.children.length) {
    e.innerHTML = d.innerHTML;
    return;
  }
  Array.from(i).some((o, n) => {
    const c = o, h = r[n], a = e.children[n];
    if (!c.isEqualNode(a)) {
      if (c.nodeName !== a.nodeName) {
        a.replaceWith(c);
        return;
      }
      Array.from(c.attributes).forEach((u) => {
        u.value !== a.getAttribute(u.name) && a.setAttribute(u.name, u.value);
      }), Array.from(a.attributes).forEach((u) => {
        !c.hasAttribute(u.name) && h.hasAttribute(u.name) && a.removeAttribute(u.name);
      }), w(c, h, a);
    }
  });
}
l(w, "deepPatchElement");
var m;
const y = (m = class extends HTMLElement {
  constructor() {
    super(), this._html = {
      cached: null,
      template: async () => {
        var t;
        return ((t = this.html) == null ? void 0 : t.call(this)) ?? "<slot></slot>";
      }
    }, this._css = {
      cached: null,
      template: async () => {
        var e, s, i;
        const t = ((e = this.options) == null ? void 0 : e.cssReset) || ((s = this.options) == null ? void 0 : s.cssReset) === void 0;
        return `
        @layer reset, default; @layer reset {
          :host { box-sizing: border-box; display: block; }
          :host([hidden]) { display: none; }
          :where(*, ::before, ::after, :host::before, :host::after):not([no-css-reset]) { box-sizing: border-box; ${t ? "color: inherit; text-decoration: inherit; font-size: inherit; line-height: inherit; font-weight: inherit; font-family: inherit; text-indent: 0; background-color: transparent; border: 0 solid transparent; padding: 0; margin: 0;" : ""}}
          ${t ? `
          :where(table):not([no-css-reset]) { border-color: inherit; border-collapse: collapse; }
          :where(img, svg, video, canvas, audio, iframe, embed, object):not([no-css-reset]) { display: block; max-width: 100%; height: auto; }
          :where(button, [role="button"]):not([no-css-reset]) { font-size: 100%; text-transform: none; cursor: pointer; }
          ` : ""}}
        ${`@layer default {${(i = this.css) == null ? void 0 : i.call(this)}}` ?? ""}
      `;
      }
    }, this.attachShadow({ mode: "open" });
  }
  /**
   * The class name of the component in dash-case.
   *
   * @example
   * ```
   * class MyElement extends MinzeElement {}
   * MyElement.dashName
   * ```
   */
  static get dashName() {
    return b(this.name);
  }
  /**
   * The class name of the component instance in dash-case.
   *
   * @example
   * ```
   * class MyElement extends MinzeElement {
   *   onStart = () => {
   *     console.log(this.dashName) // my-element
   *   }
   * }
   * ```
   */
  get dashName() {
    return b(this.constructor.name);
  }
  /**
   * The class name of the component instance.
   *
   * @example
   * ```
   * class MyElement extends MinzeElement {
   *   onStart = () => {
   *     console.log(this.name) // MyElement
   *   }
   * }
   * ```
   */
  get name() {
    return this.constructor.name;
  }
  /**
   * Registers element as a custom web component.
   *
   * @param name - The name of the custom web component.
   *
   * @example
   * ```
   * class MyElement extends MinzeElement {}
   * MyElement.define()
   * // or
   * MyElement.define('my-element')
   * ```
   */
  static define(t) {
    t ?? (t = b(this.name)), customElements && (customElements.get(t) ?? customElements.define(t, this));
  }
  /**
   * Renders the template into the shadow DOM.
   * Removes any previously registered event listeners.
   * Attaches all new event listeners.
   *
   * @param force - Forces the re-rendering of the template regardless of caching.
   *
   * @example
   * ```
   * this.render()
   * ```
   */
  async render(t) {
    var e, s, i, r, o;
    if (this.shadowRoot) {
      const n = await this._html.template(), c = await this._css.template();
      if ((c !== this._css.cached || t) && (async () => (this._css.cached = c, this.shadowRoot && (this.shadowRoot.adoptedStyleSheets = [
        await new CSSStyleSheet().replace(c)
      ])))(), n !== this._html.cached || t) {
        const h = this._html.cached;
        this._html.cached = n, await ((e = this.beforeRender) == null ? void 0 : e.call(this)), (s = this._eventListeners) == null || s.forEach(
          async (f) => this.registerEvent(f, "remove")
        ), !h || t ? this.shadowRoot.innerHTML = n : R(n, h, this.shadowRoot);
        const a = await this.mergeEvents(
          this._eventListeners,
          this.html
        );
        this._eventListeners = await this.bindEvents(a), (i = this._eventListeners) == null || i.forEach(
          async (f) => this.registerEvent(f, "add")
        ), (r = this.afterRender) == null || r.call(this), (o = this.onRender) == null || o.call(this);
      }
    }
  }
  /**
   * Leverages the View Transition API while rendering.
   *
   * @param force - Forces the re-rendering of the template regardless of caching.
   *
   * @url https://developer.mozilla.org/docs/Web/API/View_Transitions_API
   *
   * @example
   * ```
   * this.renderWithTransition()
   * ```
   */
  async renderWithTransition(t) {
    var e;
    (e = this.options) != null && e.viewTransitions && document.startViewTransition ? document.startViewTransition(async () => this.render(t)) : this.render(t);
  }
  /**
   * Re-renders the component template, invalidating all caches.
   *
   * @example
   * ```
   * this.rerender()
   * ```
   */
  rerender() {
    this.renderWithTransition(!0);
  }
  /**
   * Selects the first matching element inside the shadow DOM.
   *
   * @param selectors - A valid CSS selector string.
   *
   * @example
   * ```
   * this.select('div')
   * ```
   */
  select(t) {
    const e = this.shadowRoot;
    return (e == null ? void 0 : e.querySelector(t)) ?? null;
  }
  /**
   * Selects element(s) inside the shadow DOM.
   *
   * @param selectors - A valid CSS selector string.
   *
   * @example
   * ```
   * this.selectAll('div')
   * ```
   */
  selectAll(t) {
    const e = this.shadowRoot;
    return (e == null ? void 0 : e.querySelectorAll(t)) ?? null;
  }
  /**
   * Returns an array of slotted element(s) for provided slot name, otherwise `null` if none found.
   * Works only after the template has rendered, otherwise returns `null`.
   * Can be used inside the `afterRender` or `onReady` hooks.
   *
   * @param name - The name of the slot or empty / `default` for the default slot.
   *
   * @example
   * ```
   * this.slotted('default')
   * ```
   */
  slotted(t) {
    var s;
    const e = this.selectAll("slot");
    if (e) {
      const i = t === "default" || t === void 0 ? "" : t, r = Array.from(e).filter((o) => o.name === i);
      return ((s = r == null ? void 0 : r[0]) == null ? void 0 : s.assignedElements()) ?? null;
    }
    return null;
  }
  /**
   * Exposes property as an attribute on the element.
   *
   * @param name - The name of the attribute.
   * @param value - The value for the attribute.
   *
   * @example
   * ```
   * this.exposeAttr('active', false)
   * ```
   */
  exposeAttr(t, e) {
    const s = b(t);
    this.setAttribute(
      s,
      typeof e == "object" ? JSON.stringify(e) : String(e)
    );
  }
  /**
   * Callback, executes a set of methods on reactive changes.
   *
   * @param type - The type of property that changed.
   * @param rootName - The name of the root property that changed.
   * @param target - The target of the property that changed.
   * @param key - The name of the property that changed.
   * @param newValue - The new value of the property that changed.
   * @param oldValue - The old value of the property that changed.
   *
   * @example
   * ```
   * this.reactiveChange(type, rootName, target, prop, newValue, oldValue)
   * ```
   */
  async reactiveChange(t, e, s, i, r, o) {
    var h;
    const n = e, c = b(e);
    (h = this.watch) == null || h.forEach(async ([a, f]) => {
      (a === n || t === "attr" && a === c) && (f = f.bind(this), f(r, o, i, s));
    }), this.renderWithTransition();
  }
  /**
   * Makes a complex object deeply reactive.
   *
   * @param name - The name of the property.
   * @param prop - The property to be made reactive.
   * @param exposeAttr - Whether to expose the property as an attribute.
   *
   * @example
   * ```
   * this.makeComplexReactive('active', {deeply: {nested: true}}, true)
   * ```
   */
  makeComplexReactive(t, e, s) {
    const i = t, r = e;
    s && this.exposeAttr(i, r);
    const o = /* @__PURE__ */ l(() => ({
      get: (c, h) => {
        if (h === v)
          return !0;
        let a = Reflect.get(c, h);
        return typeof a == "object" && a && !a[v] && (a = n(a), Reflect.set(c, h, a)), a;
      },
      set: (c, h, a) => {
        const f = Reflect.get(c, h);
        return f !== a && (Reflect.set(c, h, a), s && this.exposeAttr(i, r), this.reactiveChange(
          "complex",
          i,
          c,
          h,
          a,
          f
        )), !0;
      }
    }), "createTrap"), n = /* @__PURE__ */ l((c) => new Proxy(c, o()), "createProxy");
    this[i] = n(r);
  }
  /**
   * Makes a primitive value reactive.
   *
   * @param name - The name of the property.
   * @param prop - The property to be made reactive.
   * @param exposeAttr - Whether to expose the property as an attribute.
   *
   * @example
   * ```
   * this.makePrimitiveReactive('count', 99)
   * ```
   */
  makePrimitiveReactive(t, e, s) {
    const i = t, r = `_$reactive-${t}`;
    this[r] = e, s && this.exposeAttr(t, e), Object.defineProperty(this, t, {
      get: () => this[r],
      set: (o) => {
        const n = this[r];
        n !== o && (this[r] = o, s && this.exposeAttr(t, o), this.reactiveChange(
          "primitive",
          i,
          this,
          i,
          o,
          n
        ));
      }
    });
  }
  /**
   * Makes provided property reactive.
   *
   * @param prop - The MinzeProp to be made reactive.
   *
   * @example
   * ```
   * this.registerProp(prop)
   * ```
   */
  registerProp(t) {
    const e = typeof t == "string" ? t : t[0], s = typeof t == "string" ? null : t[1], i = typeof t == "string" ? void 0 : t[2], r = e;
    if (r in this) {
      g(
        `A property with the name "${r}" already exists in this component.`
      );
      return;
    }
    s && typeof s == "object" ? this.makeComplexReactive(
      r,
      s,
      i
    ) : this.makePrimitiveReactive(r, s, i);
  }
  /**
   * Makes provided property reactive to attribute changes on the component.
   *
   * @param attr - The MinzeAttr to be made reactive.
   *
   * @example
   * ```
   * this.registerAttr(attr)
   * ```
   */
  registerAttr(t) {
    const e = typeof t == "string" ? t : t[0], s = typeof t == "string" ? null : t[1], i = E(e), r = e, o = i, n = typeof s == "object" ? JSON.stringify(s) : String(s);
    if (i in this) {
      g(`A property with the name "${i}" already exists.`);
      return;
    }
    const c = `_$attr-${i}`;
    this[c] = n, Array.isArray(t) && t.length === 2 && !this.getAttribute(r) && this.setAttribute(r, n), Object.defineProperty(this, i, {
      get: () => {
        var a;
        const h = (a = this.getAttribute(r)) == null ? void 0 : a.trim();
        if (h == null)
          return null;
        if (h === "undefined")
          return;
        if (h === "")
          return !0;
        try {
          return JSON.parse(h);
        } catch {
          return h;
        }
      },
      set: (h) => {
        const a = this[c];
        a !== h && (this[c] = h, this.reactiveChange(
          "attr",
          o,
          this,
          o,
          h,
          a
        ));
      }
    });
  }
  /**
   * Merges any on:events from the provided template with the eventListeners array.
   *
   * @param eventListeners - An eventListeners array.
   * @param template - A template function or string with html markup.
   *
   * @example
   * ```
   * this.mergeEvents(this._eventListeners, this.html)
   * ```
   */
  async mergeEvents(t, e) {
    if (!e)
      return t;
    e = typeof e == "function" ? e() : e;
    const s = new RegExp(`(?<=\\s+)(?:on:|@)([\\w\\-:.]+)(?:=(?:"|')?(\\w+)(?:"|')?)?(?=\\s+|\\/|>)`, "gi"), i = [
      ...new Set(
        [...e.matchAll(s)].map(
          (n) => JSON.stringify(n.slice(0, 3))
        )
      )
    ].map((n) => JSON.parse(n)), r = i.length, o = (t == null ? void 0 : t.length) ?? 0;
    if (r && o !== o + r) {
      t ?? (t = []);
      const n = /* @__PURE__ */ l((c) => c.replace(/(@|:|\.)/g, (h, a) => `\\${a}`), "escape");
      return i.map(
        ([c, h, a]) => [
          `[${n(c)}]`,
          h,
          this[a ?? h]
        ]
      );
    }
    return t;
  }
  /**
   * Automatically binds all event listener callbacks that are component methods.
   *
   * @param eventListeners - An eventListeners array.
   *
   * @example
   * ```
   * this.bindEvents(this._eventListeners)
   * ```
   */
  async bindEvents(t) {
    if (t)
      return t.map((e) => {
        const s = e[2];
        return s && this[s.name] && !s.name.startsWith("bound ") && (e[2] = s.bind(this)), e;
      });
  }
  /**
   * Adds or removes a provided event listener.
   *
   * @param eventTuple - The event tuple to be added or removed.
   * @param action - The action to be performed.
   *
   * @example
   * ```
   * this.registerEvent(this.eventListeners[0], 'add')
   * ```
   */
  registerEvent(t, e) {
    var n;
    const [s, i, r] = t;
    let o;
    s === window || s instanceof BroadcastChannel ? o = [s] : s instanceof m ? o = [this] : typeof s == "string" && (o = (n = this.shadowRoot) == null ? void 0 : n.querySelectorAll(s)), o == null || o.forEach((c) => {
      e === "add" ? c.addEventListener(i, r) : c.removeEventListener(i, r);
    });
  }
  /**
   * Dispatches a custom event from the web component.
   *
   * It's a good idea to namespace the event name. For example: `minze:update`
   *
   * @param eventName - The name of the event to be dispatched.
   * @param detail - The detail data to be passed with the event.
   *
   * @example
   * ```
   * this.dispatch('minze:update', { amount: 10 })
   * ```
   */
  dispatch(t, e) {
    this.dispatchEvent(
      new CustomEvent(t, {
        detail: e,
        bubbles: !0,
        composed: !0,
        cancelable: !0
      })
    );
  }
  /**
   * @deprecated use dispatch instead.
   */
  cast(t, e) {
    g("cast is deprecated use dispatch instead."), this.dispatch(t, e);
  }
  /**
   * Automatically exports all parts and exportparts present in the template.
   *
   * @param template - A template function or string with html markup.
   *
   * @example
   * ```
   * this.exportParts(this.html)
   * ```
   */
  exportParts(t) {
    t = typeof t == "function" ? t() : t;
    const e = /(?:part|exportparts)=["']?([\w\-_,\s]+)["']?/gi, s = [
      ...new Set(
        [...t.matchAll(e)].flatMap((i) => {
          var r;
          return (r = i.at(1)) == null ? void 0 : r.trim().replace(/,?\s+/g, ",").split(",");
        })
      )
    ].sort();
    s.length && this.setAttribute("exportparts", s.join(", "));
  }
  /**
   * Adds or removes exportparts attribute observer.
   *
   * @param action - The action to be performed.
   * @param key - The name for the oberver.
   *
   * @example
   * ```
   * this.registerExportpartsObserver('add')
   * ```
   */
  registerExportpartsObserver(t) {
    const e = "_exportpartsObserver", s = t === "add" && !this[e], i = t === "remove" && this[e];
    if (s && this.shadowRoot) {
      const r = /* @__PURE__ */ l((n) => {
        n && this.shadowRoot && this.exportParts(this.shadowRoot.innerHTML);
      }, "callback"), o = { subtree: !0, attributeFilter: ["exportparts"] };
      this[e] = C(this.shadowRoot, r, o);
    } else
      i && (this[e].disconnect(), delete this[e]);
  }
  /**
   * Logs debug information to the console.
   *
   * @example
   * ```
   * this.debuglog()
   * ```
   */
  debuglog() {
    if (!console)
      return;
    const t = Object.fromEntries(
      [
        "onStart",
        "onReactive",
        "beforeRender",
        "afterRender",
        "onReady",
        "onDestroy",
        "onMove",
        "beforeAttributeChange",
        "afterAttributeChange"
      ].filter((e) => this[e]).map((e) => [[e], this[e]])
    );
    console.groupCollapsed(
      `%c[Minze: ${this.name}] 🚧`,
      "color: rgb(110, 150, 245);"
    ), [
      ["Class: %O", this],
      ["Element: %o", this]
    ].forEach(([e, s]) => console.log(e, s)), console.groupCollapsed("Internals"), [
      ["🧨 eventListeners: %o", this._eventListeners],
      ["🪝 hooks: %o", Object.keys(t).length ? t : void 0],
      ["🔩 options: %o", this.options],
      [
        "🧬 reactive: %o",
        {
          attrs: this.attrs,
          observedAttributes: this.constructor.observedAttributes,
          reactive: this.reactive,
          watch: this.watch
        }
      ],
      ["✨ template: %o", { css: this._css, html: this._html }]
    ].forEach(([e, s]) => console.log(e, s)), console.groupEnd(), console.groupEnd();
  }
  /**
   * Lifecycle (Internal) - Runs whenever the element is appended into a document-connected element.
   */
  async connectedCallback() {
    var t, e, s, i, r, o, n, c, h;
    (t = this.onStart) == null || t.call(this), this.eventListeners && (this._eventListeners = [...this.eventListeners]), (e = this.reactive) == null || e.forEach(async (a) => this.registerProp(a)), (s = this.attrs) == null || s.forEach(async (a) => this.registerAttr(a)), (i = this.onReactive) == null || i.call(this), (o = (r = this.options) == null ? void 0 : r.exposeAttrs) != null && o.exportparts && (this.html && this.exportParts(this.html), this.registerExportpartsObserver("add")), await this.render(), (c = (n = this.options) == null ? void 0 : n.exposeAttrs) != null && c.rendered && this.setAttribute("rendered", ""), (h = this.onReady) == null || h.call(this), this.debug && this.debuglog();
  }
  /**
   * Lifecycle (Internal) - Runs each time the element is disconnected from the document's DOM.
   */
  async disconnectedCallback() {
    var t, e, s, i;
    this._html.cached = null, this._css.cached = null, (e = (t = this.options) == null ? void 0 : t.exposeAttrs) != null && e.exportparts && this.registerExportpartsObserver("remove"), (s = this._eventListeners) == null || s.forEach(
      async (r) => this.registerEvent(r, "remove")
    ), (i = this.onDestroy) == null || i.call(this);
  }
  /**
   * Lifecycle (Internal) - Runs each time the element is moved to a new document.
   */
  async adoptedCallback() {
    var t, e;
    (t = this._eventListeners) == null || t.forEach(
      async (s) => this.registerEvent(s, "remove")
    ), (e = this.onMove) == null || e.call(this);
  }
  /**
   * Lifecycle (Internal) - Runs whenever one of the element's attributes is changed.
   *
   * @param name - The name of the attribute that was changed.
   * @param oldValue - The previous value of the attribute.
   * @param newValue - The new value of the attribute.
   */
  async attributeChangedCallback(t, e, s) {
    var r, o, n;
    await ((r = this.beforeAttributeChange) == null ? void 0 : r.call(this, t, e, s));
    const i = E(t);
    i in this && s !== e && (this[i] = s), (o = this.afterAttributeChange) == null || o.call(this, t, e, s), (n = this.onAttributeChange) == null || n.call(this, t, e, s);
  }
}, l(m, "_MinzeElement"), m);
y.version = "1.10.1";
y.isMinzeElement = !0;
let T = y;
export {
  _ as Minze,
  T as MinzeElement,
  _ as default
};
